import { useId, useState } from "react";
import { authStyles as styles } from "./AuthSplitLayout";

export function AuthField({
  id,
  label,
  type = "text",
  value,
  onChange,
  placeholder,
  autoComplete,
  autoFocus,
  error,
  helper,
  testId,
  required,
}) {
  const autoId = useId();
  const inputId = id || autoId;
  const errorId = `${inputId}-error`;
  const helperId = `${inputId}-helper`;

  return (
    <div className={styles.field}>
      <label className={styles.label} htmlFor={inputId}>
        {label}
      </label>
      <input
        id={inputId}
        className={`${styles.input} ${error ? styles.inputError : ""}`}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        autoComplete={autoComplete}
        autoFocus={autoFocus}
        required={required}
        aria-invalid={error ? "true" : "false"}
        aria-describedby={[error ? errorId : null, helper ? helperId : null]
          .filter(Boolean)
          .join(" ") || undefined}
        data-testid={testId}
      />
      {helper && !error && (
        <div id={helperId} className={styles.helper}>
          {helper}
        </div>
      )}
      {error && (
        <div id={errorId} className={styles.fieldError} role="alert">
          {error}
        </div>
      )}
    </div>
  );
}

export function AuthPasswordField({
  id,
  label,
  value,
  onChange,
  placeholder,
  autoComplete,
  error,
  helper,
  testId,
  toggleTestId,
  required,
}) {
  const autoId = useId();
  const inputId = id || autoId;
  const errorId = `${inputId}-error`;
  const helperId = `${inputId}-helper`;
  const [visible, setVisible] = useState(false);

  return (
    <div className={styles.field}>
      <label className={styles.label} htmlFor={inputId}>
        {label}
      </label>
      <div className={styles.inputWrap}>
        <input
          id={inputId}
          className={`${styles.input} ${styles.inputWithToggle} ${
            error ? styles.inputError : ""
          }`}
          type={visible ? "text" : "password"}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          autoComplete={autoComplete}
          required={required}
          aria-invalid={error ? "true" : "false"}
          aria-describedby={[error ? errorId : null, helper ? helperId : null]
            .filter(Boolean)
            .join(" ") || undefined}
          data-testid={testId}
        />
        <button
          type="button"
          className={styles.toggle}
          onClick={() => setVisible((v) => !v)}
          aria-label={visible ? "Hide password" : "Show password"}
          aria-pressed={visible}
          data-testid={toggleTestId || `${testId}-toggle`}
        >
          {visible ? "Hide" : "Show"}
        </button>
      </div>
      {helper && !error && (
        <div id={helperId} className={styles.helper}>
          {helper}
        </div>
      )}
      {error && (
        <div id={errorId} className={styles.fieldError} role="alert">
          {error}
        </div>
      )}
    </div>
  );
}

export function AuthFormError({ message, testId = "auth-form-error" }) {
  if (!message) return null;
  return (
    <div className={styles.formError} role="alert" aria-live="assertive" data-testid={testId}>
      {message}
    </div>
  );
}
